export default {
  param_saveSignatureImg: {
    url: '/base-desk-manage/authnController/saveSignatureImg',
    param: {
      // isModify: 1,
      signatureImg: ''
    }
  }
}
